import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import { ICheckboxEvent, IRadioEvent } from "../../../../types";

import { InputNumber, Checkbox, Radio, Label, FormElement, TwoInOne } from "../../../../components/Form";

import { tempos, getSelectValue, rhytPatterns } from "../../../../../common/parameters";
import { Tab, Card } from "../styles";

import { NoMarginBottom } from "./styles";
import { IProps } from "./interfaces";
import messages from "./messages";

class Rhythm extends Component<IProps> {
    changeRhythmTempo = (e: IRadioEvent) => {
        const tempo = e.target.value;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "rhythm", prop: "tempo", val: tempo });
        post("save-meta-rhythm-tempo", { tempo, planId: plan._id });
    };

    changeChangingTS = (e: ICheckboxEvent) => {
        const changingTS = e.target.checked;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "rhythm", prop: "changingTS", val: changingTS });
        if (!changingTS) {
            setPlanMeta({ cat: "rhythm", prop: "timeSignatureNum2", val: "" });
            setPlanMeta({ cat: "rhythm", prop: "timeSignatureDen2", val: "" });
        }
        post("save-meta-rhythm-changing-ts", { changingTS, planId: plan._id });
    };

    changeRhythmTimeSignatureNum = (e: React.FormEvent<HTMLInputElement>) => {
        const timeSignatureNum = e.currentTarget.value.length ? +e.currentTarget.value.slice(0, 2) : undefined;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "rhythm", prop: "timeSignatureNum", val: timeSignatureNum });
        post("save-meta-rhythm-time-signature-num", { timeSignatureNum, planId: plan._id });
    };

    changeRhythmTimeSignatureDen = (e: React.FormEvent<HTMLInputElement>) => {
        const timeSignatureDen = e.currentTarget.value.length ? +e.currentTarget.value.slice(0, 2) : undefined;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "rhythm", prop: "timeSignatureDen", val: timeSignatureDen });
        post("save-meta-rhythm-time-signature-den", { timeSignatureDen, planId: plan._id });
    };

    changeRhythmTimeSignatureNum2 = (e: React.FormEvent<HTMLInputElement>) => {
        const timeSignatureNum2 = e.currentTarget.value.length ? +e.currentTarget.value.slice(0, 2) : undefined;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "rhythm", prop: "timeSignatureNum2", val: timeSignatureNum2 });
        post("save-meta-rhythm-time-signature-num-2", { timeSignatureNum2, planId: plan._id });
    };

    changeRhythmTimeSignatureDen2 = (e: React.FormEvent<HTMLInputElement>) => {
        const timeSignatureDen2 = e.currentTarget.value.length ? +e.currentTarget.value.slice(0, 2) : undefined;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "rhythm", prop: "timeSignatureDen2", val: timeSignatureDen2 });
        post("save-meta-rhythm-time-signature-den-2", { timeSignatureDen2, planId: plan._id });
    };

    changeRhythmUpbeat = (e: ICheckboxEvent) => {
        const upbeat = e.target.checked;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "rhythm", prop: "upbeat", val: upbeat });
        post("save-meta-rhythm-upbeat", { upbeat, planId: plan._id });
    };

    render() {
        const {
            plan: { meta },
            intl: { formatMessage },
            publicView,
        } = this.props;
        return (
            <Tab>
                {publicView && (
                    <>
                        <div>
                            {(meta.rhythm.timeSignatureNum || meta.rhythm.timeSignatureDen) && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.timeSignature} />
                                    </Label>
                                    {meta.rhythm.changingTS && (
                                        <FormElement>
                                            <FormattedMessage {...messages.alternating} />
                                        </FormElement>
                                    )}
                                    <TwoInOne style={{ maxWidth: 133 }}>
                                        {meta.rhythm.timeSignatureNum || "?"}
                                        <div className={cn("Gap", "GapNormal")}>/</div>
                                        {meta.rhythm.timeSignatureDen || "?"}
                                    </TwoInOne>
                                </FormElement>
                            )}
                            {(meta.rhythm.timeSignatureNum2 || meta.rhythm.timeSignatureDen2) && (
                                <FormElement>
                                    <TwoInOne style={{ maxWidth: 133 }}>
                                        {meta.rhythm.timeSignatureNum2 || "?"}
                                        <div className={cn("Gap", "GapNormal")}>/</div>
                                        {meta.rhythm.timeSignatureDen2 || "?"}
                                    </TwoInOne>
                                </FormElement>
                            )}
                            {meta.rhythm.upbeat && (
                                <FormElement>
                                    <FormattedMessage {...messages.isUpbeat} />
                                </FormElement>
                            )}
                            {meta.rhythm.patterns && meta.rhythm.patterns.length > 0 && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.rhythmPatterns} />
                                    </Label>
                                    <div>
                                        {meta.rhythm.patterns &&
                                            meta.rhythm.patterns.map(pattern => {
                                                return (
                                                    <Card key={pattern}>{rhytPatterns(formatMessage)[pattern]}</Card>
                                                );
                                            })}
                                    </div>
                                </FormElement>
                            )}
                        </div>
                        <div>
                            {meta.rhythm.tempo && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.tempoFeel} />
                                    </Label>
                                    <div>{getSelectValue(tempos(formatMessage), meta.rhythm.tempo)}</div>
                                </FormElement>
                            )}
                        </div>
                    </>
                )}

                {!publicView && (
                    <>
                        <div>
                            <div>
                                <Label required>
                                    <FormattedMessage {...messages.timeSignature} />
                                </Label>
                                <NoMarginBottom>
                                    <Checkbox
                                        label={formatMessage(messages.alternating)}
                                        checked={meta.rhythm.changingTS || false}
                                        onChange={this.changeChangingTS}
                                    />
                                </NoMarginBottom>
                                <TwoInOne style={{ maxWidth: 133 }}>
                                    <InputNumber
                                        name="timeSignatureNum"
                                        value={(meta.rhythm.timeSignatureNum || "").toString()}
                                        onChange={this.changeRhythmTimeSignatureNum}
                                    />
                                    <div className={"Gap"}>/</div>
                                    <InputNumber
                                        name="timeSignatureDen"
                                        value={(meta.rhythm.timeSignatureDen || "").toString()}
                                        onChange={this.changeRhythmTimeSignatureDen}
                                    />
                                </TwoInOne>
                                {meta.rhythm.changingTS && (
                                    <TwoInOne style={{ maxWidth: 133 }}>
                                        <InputNumber
                                            name="timeSignatureNum2"
                                            value={(meta.rhythm.timeSignatureNum2 || "").toString()}
                                            onChange={this.changeRhythmTimeSignatureNum2}
                                        />
                                        <div className={"Gap"}>/</div>
                                        <InputNumber
                                            name="timeSignatureDen2"
                                            value={(meta.rhythm.timeSignatureDen2 || "").toString()}
                                            onChange={this.changeRhythmTimeSignatureDen2}
                                        />
                                    </TwoInOne>
                                )}
                            </div>
                            <Checkbox
                                label={formatMessage(messages.isUpbeat)}
                                checked={meta.rhythm.upbeat || false}
                                onChange={this.changeRhythmUpbeat}
                            />
                            <FormElement>
                                <Label>
                                    <FormattedMessage {...messages.rhythmPatterns} />
                                </Label>
                                <div>
                                    {meta.rhythm.patterns &&
                                        meta.rhythm.patterns.map(pattern => {
                                            return <Card key={pattern}>{rhytPatterns(formatMessage)[pattern]}</Card>;
                                        })}
                                </div>
                            </FormElement>
                        </div>
                        <div>
                            <Radio
                                label={formatMessage(messages.tempoFeel)}
                                value={meta.rhythm.tempo}
                                onChange={this.changeRhythmTempo}
                                options={tempos(formatMessage)}
                                required
                            />
                        </div>
                    </>
                )}
            </Tab>
        );
    }
}

export default Rhythm;
